import React, { useEffect, useState } from "react";
import { PageTitle } from "@/components/SettingsPanel";
import { BookingsTable } from "@/pages/venue/Bookings";
import { api } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";
import type { Booking } from "@/types";
import { useLiveTick } from "@/lib/live";

export default function AdminBookings() {
  const { t } = usePrefs();
  const [list, setList] = useState<Booking[] | null>(null);
  const tick = useLiveTick();
  useEffect(() => {
    api.get("/admin/bookings").then((r) => setList(r.data)).catch(() => setList([]));
  }, [tick]);
  return (
    <div data-testid="admin-bookings-page">
      <PageTitle title={t("admin.bookingsTitle")} />
      <BookingsTable list={list} />
    </div>
  );
}
